import {cdnTemplate, jadeLocals} from "cdnPreprocessor";
import _ from "lodash";
import actions from "../../actions/product";

export default [
  '$timeout',
  '$state',
  'CartService',
  'UpsellCartService',
  'CurrencyService',
  function ShoppingCartItemsDir($timeout, $state, cart, upsellCart, CurrencyService) {
    return {
      restrict: 'E',
      scope: {
        amazonReference: '@?',
        amazonOrderId: '@?',
        amazonUpsell: '@?',
        paypalUpsell: '@?',
        disableCoupons: '@?',
        toggle: '=?'
      },
      template: require('./shopping-cart-items.jade')(jadeLocals),
      link: (scope, el) => {
        let couponTimeout;

        function setInvalid() {
          scope.couponInvalid = true;
          couponTimeout = $timeout(() => {
            scope.couponInvalid = false;
          }, 5000);
        }

        if (typeof scope.toggle != 'boolean') {
          scope.toggle = 'na';
        }

        scope.isUpsell = (scope.amazonUpsell === "true" || scope.paypalUpsell === "true");

        scope.showCoupon = (!scope.isUpsell && !scope.disableCoupons);

        scope.couponInvalid = false;
        scope.cart = scope.isUpsell ? upsellCart : cart;
        scope.cartTotals = scope.cart.getTotals();

        scope.currency = CurrencyService;
        scope.currency.init();

        scope.applyCoupon = () => {
          let apply = (!!scope.amazonReference) ?
            cart.applyCoupon(scope.couponCode, scope.amazonReference, scope.amazonOrderId) :
            cart.applyCoupon(scope.couponCode);

          apply.then((res) => {
            if (res.valid === false) {
              scope.couponMessage = "Invalid coupon.";
              setInvalid();
            }
          });

          apply.catch((err) => {
            scope.couponMessage = err.data.message;

            if (err.data && err.data.couponCode) scope.couponCode = err.data.couponCode;

            setInvalid();
          });
        };

        scope.remove = (i) => {
          cart.remove(i);
          if (scope.toggle != 'na' && cart.size() === 0) {
            scope.toggle = false;
          } else if (scope.toggle != 'na') scope.toggle = true;
        }

        scope.sizeDisplay = product => actions.sizeDisplay(product, product.size);

        scope.showHolidayMessage = () => {
          let show = true;

          _.each(cart.cart.contents, item => {
            if ((item.group === 'Sublimation Tees' || item.specialPrinting) && moment().isBefore(moment('2017-12-26'))) {
              show = true;
              return false;
            }
          });

          return show;
        };

        el.on('$destroy', () => {
          $timeout.cancel(couponTimeout);
        });
      }
    }
  }
];


// WEBPACK FOOTER //
// ./source/client/layout-components/shopping-cart/shopping-cart-items.dir.js